import { Typography } from '@arionbanki/arionui';
import { FinishPageProps } from './useFinish';
import { FLOW_TYPE } from 'consts';
import { Links } from 'components';
import screenImg from 'img/screen.svg';

export function FinishAV({ flowType, keys, links, t }: FinishPageProps) {
	return FLOW_TYPE.AV === flowType ? (
		<>
			<div className="col-12 col-md-7 col-lg-7 col-xl-7">
				<Typography TagName="h2">{t(keys.leftTitle, 'finish')}</Typography>
				<Typography TagName="p" className="my-5">
					{t(keys.leftText, 'finish')}
				</Typography>
				<Links links={links[0]} />
			</div>
			<div className="col-12 col-md-5 col-lg-5 col-xl-5">
				<img alt="" className="w-100" src={screenImg} />
			</div>
		</>
	) : null;
}
